<template>
        <div class="board-container">
            <table class="board-list mb-10">
                <thead class="d-none d-lg-table-header">
                    <tr>
                        <th style="width:10%;" class="board-list__txt">번호</th>
                        <th style="width:72%;" class="board-list__txt">제목</th>
                        <th style="width:18%;" class="board-list__txt">작성일</th>
                        <th style="width:18%;" class="board-list__txt">조회</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(notice, index) in notices" :key="`notice-${index}`">
                        <td align="center" class="board-list__txt board-list__txt--first">
                            <v-icon>{{ mdiAlertCircleOutline }}</v-icon>
                        </td>
                        <td align="center" class="board-list__tit" @click="showBoard(notice)">
                            <div class="ellip">{{ notice.subject }}</div>
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ notice.createdAt.toDate() }}
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ notice.viewCount }}
                        </td>
                    </tr>
                    <tr v-for="(board, index) in boards" :key="`board-${index}`">
                        <td align="center" class="board-list__txt board-list__txt--first">
                            {{ summary.totalCount - skip - index }}
                        </td>
                        <td align="center" class="board-list__tit" @click="showBoard(board)">
                            <div class="ellip">{{ board.subject }}</div>
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ board.createdAt.toDate() }}
                        </td>
                        <td align="center" class="board-list__txt">
                            {{ board.viewCount }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- <div role="table" class="board-table board-table--solid">
                <div role="rowgroup">
                    <div role="row">
                        <div role="columnheader" class="num">번호</div>
                        <div role="columnheader" class="tit">제목</div>
                        <div role="columnheader" class="date">작성일</div>
                        <div role="columnheader" class="num">조회</div>
                    </div>
                </div>
                <div role="rowgroup">
                    <div v-for="(notice, index) in notices" :key="`notice-${index}`" role="row">
                        <div role="cell" class="num">
                            <v-icon>{{ mdiAlertCircleOutline }}</v-icon>
                        </div>
                        <div role="cell" class="tit font-weight-bold">
                            <a @click="showBoard(notice)">{{ notice.subject }}</a>
                        </div>
                        <div role="cell" class="date font-weight-bold">
                            <span class="date">{{ notice.createdAt.toDate() }}</span>
                        </div>
                        <div role="cell" class="num font-weight-bold">
                            <span class="num">{{ notice.viewCount }}</span>
                        </div>
                    </div>
                </div>
                <div role="rowgroup">
                    <div v-for="(board, index) in boards" :key="`board-${index}`" role="row">
                        <div role="cell" class="num">{{ summary.totalCount - skip - index }}</div>
                        <div role="cell" class="tit">
                            <a @click="showBoard(board)">{{ board.subject }}</a>
                        </div>
                        <div role="cell" class="date">
                            <span class="date">{{ board.createdAt.toDate() }}</span>
                        </div>
                        <div role="cell" class="num">
                            <span class="num">{{ board.viewCount }}</span>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="board-buttons board-buttons--center">
                <slot name="write-button" />
            </div>
            <div class="board-bottom">
                <slot name="pagination" />
            </div>
        </div>
</template>

<script>
import paginationComponent from "@/components/client/control/pagination-component.vue";

export default {
    components: { paginationComponent },

    props: {
        code: { type: String, default: null },
        summary: {
            type: Object,
            default() {
                return { totalCount: 0 };
            },
        },
        boards: { type: Array, default: null },
        notices: { type: Array, default: null },
        page: { type: Number, default: 1 },
        skip: { type: Number, default: 0 },
        limit: { type: Number, default: null },
    },
    methods: {
        changePage(page) {
            this.$emit("page", page);
        },
        showBoard(board) {
            this.$router.push(`${this.$route.path}/${board._id}`);
        },
    },
    computed: {
        count() {
            return Math.ceil(this.summary.totalCount / this.limit);
        },
    },
};
</script>
